export enum RaceType {
    MANAGED = 'managed',
    FREE = 'free',
}
